import {
  AutocompleteChangeDetails,
  AutocompleteChangeReason,
} from "@mui/material/Autocomplete";
import React, { ReactNode, SetStateAction } from "react";
import { DropdownOption } from "../../../types";
import { Country } from "./gol-country-picker";

export interface GolContactTextFieldProps extends GolFieldElement {
  multiline?: boolean;
  rowsMax?: number;
  rows?: number;
  fullWidth?: boolean;
  placeholder?: string;
}

export interface GolControlStyledLabel extends GolBaseField {
  controlName?: string;
  controlId?: string;
  label?: ReactNode;
}

export interface GolFieldElement extends GolBaseField {
  label?: string;
}

export interface GolContactCountryAutoComplete {
  id: string;
  label?: string;
  onChange: (ev: any) => void;
  name: string;
  claszName?: string;
  classes?: any;
  defaultValue: Country | undefined | string;
  defaultCountryError?: string;
  getOptionLabel: any;
}

export interface GolContactGenderDropdown {
  onChange: (ev: any) => void;
  label?: string;
  options: DropdownOption[];
  name: string;
}
interface GolBaseField {
  value?: string;
  onChange?: (ev: any) => void;
  name: string;
  clazz?: string;
  required?: boolean;
  errorMsg?: string;
  textSize?: "small" | "medium" | undefined;
  type?: string;
  inputProps?: { [key: string]: any };
  inputLabelProps?: { [key: string]: any };
}

export interface GolContactInfoInterface {
  errorMsg: { [key: string]: any };
  setValidContactInfo: React.Dispatch<SetStateAction<boolean>>;
  setValidPptInfo: React.Dispatch<SetStateAction<boolean>>;
  checkContactInfoFormValidity: boolean;
  checkContactPptInfoFormValidity: boolean;
  setCheckContactInfoFormValidity: React.Dispatch<SetStateAction<boolean>>;
  setCheckContactPptInfoFormValidity: React.Dispatch<SetStateAction<boolean>>;
}

export const GolContactInfoFormContext =
  React.createContext<GolContactInfoInterface>({} as GolContactInfoInterface);

export const GolContactFormContext = React.createContext({
  form: {} as { [key: string]: any },
  fieldsInErrors: [] as string[],
  handleFormChange: (ev: any) => {},
  requiredFields: [] as string[],
});
